interface SaveChangesBarProps {
  hasUnsavedChanges: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

const SaveChangesBar = ({
  hasUnsavedChanges,
  saving,
  onSave,
  onDiscard,
}: SaveChangesBarProps) => {
  if (!hasUnsavedChanges) return null;

  return (
    <div className="flex items-center justify-between rounded-lg border border-primaryGray-14 bg-primaryGray-16 px-6 py-4">
      <div className="flex items-center gap-3">
        <div className="h-2 w-2 animate-pulse rounded-full bg-tertiaryBlue-4" />
        <span className="text-sm font-medium text-primaryGray-1">
          You have unsaved changes
        </span>
      </div>
      <div className="flex items-center gap-3">
        <button
          disabled={saving}
          onClick={onDiscard}
          className="rounded-md border border-primaryGray-14 bg-white px-4 py-1.5 text-sm font-medium text-primaryGray-1 transition-colors hover:border-primaryGray-12 hover:bg-primaryGray-16 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Discard Changes
        </button>
        <button
          disabled={saving}
          onClick={onSave}
          className="rounded-md bg-primaryGray-1 px-4 py-1.5 text-sm font-medium text-white transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default SaveChangesBar;
